/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_Audit_ExportInputs */

const en_mk_mx_audit_export = /** @type {(inputs: Mk_Mx_Audit_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audit trail export`)
};

const id_mk_mx_audit_export = /** @type {(inputs: Mk_Mx_Audit_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ekspor catatan audit`)
};

/**
* | output |
* | --- |
* | "Audit trail export" |
*
* @param {Mk_Mx_Audit_ExportInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_audit_export = /** @type {((inputs?: Mk_Mx_Audit_ExportInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_Audit_ExportInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_audit_export(inputs)
	return en_mk_mx_audit_export(inputs)
});